import { type LodgingContext, ParentState } from "@checkout/index";
import { getObjectKeysAsObject } from "../../../helpers";
import type { ParentContextWithWallet } from "./types";

export const guards = {
  hasWalletEnabled: (context: ParentContextWithWallet) => {
    return context.featureFlags.enableWallet;
  },
  hasWalletOffers: (context: ParentContextWithWallet, _event: unknown) => {
    return (
      context[ParentState.wallet].selectedOffer ||
      context[ParentState.wallet].offers
    );
  },
  hasOfferFromAvailability: (context: LodgingContext) => {
    return context[ParentState.lodgingShop]?.bestOffer;
  },
};

export const GuardTypes = getObjectKeysAsObject(guards);
